module.exports = __webpack_public_path__ + "img/1.042f3431.png";